var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',_vm._l((_vm.items),function(item){return _c('b-col',{key:item.key,staticClass:"mc-readonly",attrs:{"cols":"12","md":"6","lg":"4"}},[_c('div',{staticClass:"mc-readonly__label"},[_vm._v(_vm._s(item.label))]),_c('div',{class:`mc-readonly__value${item.bold ? '-bold' : ''}`},[_vm._v(_vm._s(item.value))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }